import React from "react";
import ProfileInlineEditInput from "./ProfileInlineEditInput.js";
import InlineEditValidatedInputWysiwyg from "../../common/widgets/InlineEditValidatedInputWysiwyg.js";

/**
 * Generic component for all profile editable wysiwyg fields
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
export default function ProfileInlineEditInputWysiwyg(props) {
  return <ProfileInlineEditInput InlineEditInputComponent={InlineEditValidatedInputWysiwyg} {...props}/>
};
